export const trackingEvents = {
  PAGE: {
    VIEWED: 'watchlist_documents.page.viewed',
  },
  RESOLVE_BTN: {
    CLICKED: 'watchlist_documents.resolve_btn.clicked',
  },
}
